import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getUsers() {
    return dispatch => {
        return apiCaller
            .call(api.getAllUsers())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_USERS',
                        users: data.users
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEUsers - ', error);
                throw error;
            });
    };
}

export { getUsers };



// WEBPACK FOOTER //
// ./environments/fhe/data/Users/actions.js